export enum EInputOutputUrls {
  IO = 'io',
  CATEGORIES = 'categories',
}

export const ioCategoriesUrl = `${EInputOutputUrls.IO}/${EInputOutputUrls.CATEGORIES}`;
